export default {"src":"/_next/static/media/groepsles.be6a3f28.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};